"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox2 = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_elements_icon_1 = require("@unboared/base-ui.elements.icon");
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const CHECKBOX_SIZE = 25;
const CheckBox2 = ({ value, disabled = false, onValueChange, color, style, size = CHECKBOX_SIZE, }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const theme = (0, base_ui_theme_themes_1.useTheme)();
    // const [state, setState]
    const checkboxStyle = {
        display: 'flex',
        width: normalize(size),
        height: normalize(size),
        backgroundColor: value ? color || theme.buttonColor : 'rgba(255,255,255,0.9)',
        borderRadius: normalize(0.33333 * size),
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: normalize(0.1 * size),
        borderColor: base_ui_theme_colors_1.base_color.dark_secondary,
        cursor: 'pointer',
    };
    return (react_1.default.createElement(react_native_1.Pressable, { style: checkboxStyle, onPress: onValueChange ? () => onValueChange(!disabled && !value) : undefined }, value && (react_1.default.createElement(base_ui_elements_icon_1.Icon, { name: "io-checkmark-sharp", size: 0.66666 * size, color: "white" }))));
};
exports.CheckBox2 = CheckBox2;
//# sourceMappingURL=checkbox2.js.map